// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__C-9_A","bigColWidth":"Table_bigColWidth__2hOjz","biggerColWidth":"Table_biggerColWidth__3cP6F","row":"Table_row__1GpLf","col":"Table_col__8rEei"};